/**
 * Perfil de suelta del embrague para dispositivos sin pedal analógico.
 * La suelta es rápida en la parte alta del recorrido, LENTA a través de la
 * zona del punto de fricción (donde se decide calarse o no) y media al final.
 * El jugador conserva el control: puede volver a pisar en cualquier momento.
 */

/** Baja el pedal (soltar) un paso dt con el perfil graduado. */
export function clutchReleaseStep(pedal: number, dt: number): number {
  const rate = pedal > 0.68 ? 3.4 : pedal > 0.3 ? 0.55 : 2.2;
  return Math.max(0, pedal - rate * dt);
}

/** Suelta "de crucero": con el coche ya rodando no hace falta tanta finura. */
export function clutchCruiseReleaseStep(pedal: number, dt: number): number {
  return Math.max(0, pedal - 2.4 * dt);
}

/** Sube el pedal (pisar) un paso dt. Pisar es rápido, como en la realidad. */
export function clutchPressStep(pedal: number, dt: number): number {
  return Math.min(1, pedal + 6 * dt);
}
